import React, { useEffect, useState } from "react";
import { useDataLoader } from "react-remote-data-hooks";
import { ILeadAction } from "../../../../core/api/models";
import "react-widgets/dist/css/react-widgets.css";
import api from "../../../../api";
import {
  useLead,
  Dict,
  LeadState,
  AppPermissions,
  useHasPermission,
  Lead,
  State,
  DateFormats,
  getMinutes,
  getNearestFutureTime,
} from "../../../../core";
import AddInterestedProject from "./AddInterestedProject";
import MapLeadQuality from "./MapLeadQuality";
import ConvertAsEnquiry from "./ConvertAsEnquiry";
import MapTag from "./MapTag";
import classnames from "classnames";
import { useLeadCalendarContext } from "../../../../core/hooks/useLeadCalendarContext";
import { EditEventPopup } from "../activities/edit-event-popup";
import { checkPermission } from "../../../../utils/checkPermission";
import { useSelector } from "react-redux";
import { AddUserPopup } from "./AddUser";
import { useAppSettings } from "../../../../core/hooks/useAppSettings";
import moment from "moment";
import { combineDateAndTime } from "../../../../utils/CombineDateAndTime";
import DeleteLead from "./DeleteLead";
import { RouteKeys } from "../../../routes/route-keys";
import { useHistory } from "react-router";
import AddNewRequirement from "./AddNewRequirement";
import AssignCompany from "./AssignCompany";
import LeadMerge from "./LeadMerge";
import MergeCustomer from "./MergeCustomer";
import MergeCompany from "./MergeCompany";

export const colors: Dict = {
  addNewRequirement: "bg-slateblue",
  createProposal: "bg-red",
  addANewVehicle: "bg-yellow",
  scheduleAShowroomVisit: "bg-shamrock",
  convertAsEnquiry: "bg-orange",
  otherActions: "bg-yellow",
  call: "bg-yellow",
  timeOff: "bg-slateblue",
  vehicleTimeOff: "bg-shamrock",
  addUser: "bg-red",
};

interface IActionProps {
  lead: LeadState;
  onUpdate?: () => void;
  leads?: Lead[];
  disableConvertEnquiry?: boolean;
  onReload?: () => void;
}
const Actions: React.FunctionComponent<IActionProps> = (props) => {
  const appSettings = useAppSettings(api.settings);
  const authState = useSelector((state: State) => state.authUser);
  const leadState = props.lead;
  const { getLeadAction, getLead } = useLead(api.lead);
  const [formModal, setFormModal] = React.useState<Dict>({});
  const [actions, setActions] = useState<ILeadAction[]>([]);
  const canSetLeadQuality = useHasPermission(AppPermissions.SetLeadQuality);
  const canMapTags = useHasPermission(AppPermissions.MapTags);
  const [addProjectModal, setAddProjectModal] = React.useState<boolean>(false);
  const [addMapCompany, setAddMapCompany] = React.useState<boolean>(false);
  const [leadMerge, setLeadMerge] = React.useState(false);
  const [mergeCustomer, setMergeCustomer] = React.useState(false);
  const [mergeCompany, setMergeCompany] = React.useState(false);
  useEffect(() => {
    assignActions();
  }, [leadState.leadActions]);
  useEffect(() => {
    assignActions();
  }, []);

  const assignActions = () => {
    let tempActions = leadState.leadActions ?? [];
    const otherAction: ILeadAction = {
      name: "Create Activity",
      code: "call",
      _id: "call",
    };
    tempActions.push(otherAction);

    if (!leadState?.leadDetails?.company?._id) {
      tempActions = tempActions?.filter(
        (x) => x.code !== "addUser" && x.code !== "createProposal"
      );
    }
    setActions(tempActions);
  };
  const { data, reload } = useDataLoader<ILeadAction>(() =>
    getLeadAction(leadState?.leadDetails?._id)
  );
  const {
    setShowCalendar,
    relaodTrigger,
    setRelaodTrigger,
  } = useLeadCalendarContext();

  const isQualityAssigned =
    leadState?.leadDetails?.quality === "interested" ? true : false;
  const isQualityOSL =
    leadState?.leadDetails?.quality === "notIntrested" ? true : false;
  const calendarPopupList = [
    "scheduleATestDrive",
    "scheduleAShowroomVisit",
    "requestACallBack",
    "call",
  ];

  useEffect(() => {
    if (
      Object.keys(formModal).length > 0 &&
      (formModal.scheduleATestDrive ||
        formModal.scheduleAShowroomVisit ||
        formModal.requestACallBack)
    ) {
      setShowCalendar(true);
    } else {
      setShowCalendar(false);
    }
  }, [formModal]);

  const renderForm = (action: ILeadAction) => {
    if (action.code === "convertAsEnquiry") {
      return renderConvertAsEnquiryForm(action._id);
    }
    if (action.code === "addUser") {
      return renderAddUser(action._id);
    }
    return <></>;
  };

  const renderAddUser = (actionId: string) => {
    return (
      <AddUserPopup
        onClose={() => {
          setFormModal({});
        }}
        onSucccess={() => {
          props.onUpdate?.();
        }}
        companyId={props.lead?.leadDetails?.company?._id}
      ></AddUserPopup>
    );
  };

  const onSuccess = () => {
    setRelaodTrigger(!relaodTrigger);
    setFormModal({});
  };

  const renderConvertAsEnquiryForm = (actionId: string) => {
    return (
      <ConvertAsEnquiry
        leadId={leadState.leadDetails?._id}
        onClose={() => setFormModal({})}
        actionId={actionId}
        onSuccess={() => {
          props.onUpdate?.();
          setFormModal({});
          getLead(leadState.leadDetails?._id);
          reload();
        }}
        isQualityOSL={isQualityOSL}
        quality={leadState?.leadDetails?.quality}
      ></ConvertAsEnquiry>
    );
  };

  const minimumDurationInMinutes = getMinutes(
    appSettings?.data?.activity?.activityMinimumDuration || {
      value: 15,
      unit: "Minutes",
    }
  );

  const startDateTime = combineDateAndTime(
    moment().startOf("day").toDate(),
    appSettings?.data?.application?.appointmentTime?.start || "9:30 AM"
  );
  return leadState.leadDetails ? (
    <div className="p-4 accordion__body border-bottom">
      <div className="tabButtonContent">
        <div className="tabButtonContent__item tabButtonContent__item--active">
          <div className="accordion accordion--sm ">
            {canSetLeadQuality && (
              <div className="accordion__panel accordion__panel--open">
                <div
                  onClick={() =>
                    setFormModal({
                      showMapLeadQuality: !formModal.showMapLeadQuality,
                    })
                  }
                  className="accordion__head border d-flex align-items-center rounded cursor-pointer mb-2 mmmd"
                >
                  <div className="rounded bg-blue text-white accordion__head-icon d-flex align-items-center justify-content-center font-xxxs mr-2">
                    <i
                      className={`${
                        formModal.showMapLeadQuality
                          ? "icon-chevron-left"
                          : "icon-chevron-right"
                      }`}
                    ></i>
                  </div>
                  <div className="font-sm font-weight-semibold text-gray-700 pl-1">
                    {isQualityAssigned
                      ? " Update Lead Quality"
                      : "Map Lead Quality to Get Started"}
                  </div>
                </div>

                {checkPermission('mergeLeads', authState?.apiPermissions) ?<div
                  onClick={() =>
                    setLeadMerge(true)
                  }
                  className="accordion__head border d-flex align-items-center rounded cursor-pointer mb-2 mmmd"
                >
                  <div className="rounded bg-yellow text-white accordion__head-icon d-flex align-items-center justify-content-center font-xxxs mr-2">
                    <i
                      className={`${
                        formModal.showMapLeadQuality
                          ? "icon-chevron-left"
                          : "icon-chevron-right"
                      }`}
                    ></i>
                  </div>
                  <div className="font-sm font-weight-semibold text-gray-700 pl-1">
                  Merge Leads
                  </div>
                </div> : null}

                {checkPermission("mergeCustomer", authState?.apiPermissions) &&
                  !leadState.leadDetails?.company &&
                  leadState.leadDetails?.customer && (
                    <div
                      onClick={() => setMergeCustomer(true)}
                      className="accordion__head border d-flex align-items-center rounded cursor-pointer mb-2 mmmd"
                    >
                      <div className="rounded bg-blue text-white accordion__head-icon d-flex align-items-center justify-content-center font-xxxs mr-2">
                        <i
                          className={`${
                            formModal.showMapLeadQuality
                              ? "icon-chevron-left"
                              : "icon-chevron-right"
                          }`}
                        ></i>
                      </div>
                      <div className="font-sm font-weight-semibold text-gray-700 pl-1">
                        Merge Customer
                      </div>
                    </div>
                  )}
                {checkPermission("mergeCompany", authState?.apiPermissions) &&
                  leadState.leadDetails?.company &&
                   (
                    <div
                      onClick={() => setMergeCompany(true)}
                      className="accordion__head border d-flex align-items-center rounded cursor-pointer mb-2 mmmd"
                    >
                      <div className="rounded bg-blue text-white accordion__head-icon d-flex align-items-center justify-content-center font-xxxs mr-2">
                        <i
                          className={`${
                            formModal.showMapLeadQuality
                              ? "icon-chevron-left"
                              : "icon-chevron-right"
                          }`}
                        ></i>
                      </div>
                      <div className="font-sm font-weight-semibold text-gray-700 pl-1">
                        Merge Company
                      </div>
                    </div>
                  )}
                {formModal.showMapLeadQuality && (
                  <MapLeadQuality
                    className="row mx-0"
                    lead={leadState.leadDetails}
                    onClose={() => setFormModal({})}
                    onSuccess={props.onUpdate}
                    leads={props.leads}
                    action={actions?.find((x) => x.code === "requestACallBack")}
                  ></MapLeadQuality>
                )}
                {leadMerge && (
                  <LeadMerge
                    leadDetails={props?.lead?.leadDetails}
                    onClose={() => setLeadMerge(false)}
                    onReload={props?.onReload}
                  >
                    {" "}
                  </LeadMerge>
                )}
                {formModal.addNewRequirement && (
                  <AddNewRequirement
                    className="row mx-0"
                    lead={leadState?.leadDetails}
                    leadId={leadState?.leadDetails._id || ""}
                    customerId={leadState?.leadDetails?.customer?._id || ""}
                    onClose={() => setFormModal({})}
                    onReload={() => {
                      getLead(leadState?.leadDetails?._id!);
                    }}
                  ></AddNewRequirement>
                )}

                {mergeCustomer && (
                  <MergeCustomer
                    leadDetails={props?.lead?.leadDetails}
                    onClose={() => setMergeCustomer(false)}
                    onReload={props?.onReload}
                  >
                    {" "}
                  </MergeCustomer>
                )}
                {mergeCompany && (
                  <MergeCompany
                    leadDetails={props?.lead?.leadDetails}
                    onClose={() => setMergeCompany(false)}
                    onReload={props?.onReload}
                  >
                    {" "}
                  </MergeCompany>
                )}
              </div>
            )}
            {canMapTags && (
              <div className="accordion__panel accordion__panel--open">
                {formModal.showMapTgs && (
                  <MapTag
                    leadDetails={leadState.leadDetails}
                    onClose={() => setFormModal({})}
                    onSuccess={props.onUpdate}
                  ></MapTag>
                )}
              </div>
            )}
            {actions?.map((action) => {
              if (action.code === "scheduleAShowroomVisit") {
                return <></>;
              }
              if (
                leadState.leadDetails?.isDeal === false &&
                action.code === "addNewRequirement"
              ) {
                return <></>;
              }
              if (
                action.code === "createProposal" &&
                (!leadState.leadDetails?.requirements?.length ||
                  leadState.leadDetails?.isDeal === false)
              ) {
                return <></>;
              }
              return checkPermission(action.code, authState?.apiPermissions) ? (
                <div className="accordion__panel accordion__panel--open">
                  <div
                    onClick={() => {
                      if (action?.code !== "call" && !isQualityAssigned) {
                        return;
                      }

                      if (formModal[action.code]) {
                        setFormModal({});
                      } else {
                        setFormModal({
                          [action.code]: !formModal[action.code],
                        });
                      }
                    }}
                    className={classnames({
                      "accordion__head border d-flex align-items-center rounded cursor-pointer mb-2": true,
                      "bg-gray-100":
                        !isQualityAssigned && action?.code !== "call",
                    })}
                  >
                    <div
                      className={classnames({
                        "rounded text-white accordion__head-icon d-flex align-items-center justify-content-center font-xxxs mr-2": true,
                        "bg-gray-300":
                          !isQualityAssigned && action?.code !== "call",
                        [colors[action.code]]:
                          isQualityAssigned || action.code === "call",
                      })}
                    >
                      <i className="icon-chevron-right"></i>
                    </div>
                    <div className="font-sm font-weight-semibold text-gray-700 pl-1">
                      {action.name}
                    </div>
                  </div>
                  {formModal[action.code] &&
                    calendarPopupList.indexOf(action.code) === -1 &&
                    (isQualityAssigned || action.code === "call") &&
                    renderForm(action)}
                  {formModal[action.code] &&
                    (isQualityAssigned || action.code === "call") &&
                    calendarPopupList.indexOf(action.code) !== -1 && (
                      <EditEventPopup
                        action={action}
                        isEdit={false}
                        currentActivity={{
                          type: action.code,
                          title: "",
                          timePeriod: {
                            startDate: new Date(),
                            startTime:
                              appSettings?.data?.application?.appointmentTime
                                ?.start || "9:00 AM",
                            endTime:
                              moment(startDateTime)
                                .add(minimumDurationInMinutes, "minute")
                                .format(DateFormats.TimeOnlyFormat) ||
                              "9:30 AM",
                          },
                          showRoom: leadState?.leadDetails?.showroom
                            ? {
                                _id:
                                  leadState?.leadDetails?.showroom?._id || "",
                                title: leadState?.leadDetails?.showroom?.title,
                              }
                            : undefined,
                          salesPerson: authState?.profile
                            ? {
                                _id: authState?.profile?._id || "",
                                name: authState?.profile?.name,
                                knownAs: authState?.profile?.knownAs,
                              }
                            : undefined,
                          busyEvent: true,
                          company: leadState?.leadDetails?.company,
                        }}
                        onClose={() => {
                          setFormModal({});
                        }}
                        onSubmit={(updatedEvent) => {
                          // onSubmitActivity(updatedEvent);
                        }}
                        leadId={leadState?.leadDetails?._id!}
                        customerId={leadState?.leadDetails?.customer?._id!}
                        loadCurrentTime
                      ></EditEventPopup>
                    )}
                </div>
              ) : (
                <></>
              );
            })}

            <div className="accordion__panel accordion__panel--open">
              <div
                onClick={() => {
                  if (isQualityAssigned) {
                    setAddProjectModal(true);
                  }
                }}
                className={classnames({
                  "accordion__head border d-flex align-items-center rounded cursor-pointer mb-2": true,
                  "bg-gray-100": !isQualityAssigned,
                })}
              >
                <div
                  className={classnames({
                    "rounded text-white accordion__head-icon d-flex align-items-center justify-content-center font-xxxs mr-2": true,
                    "bg-gray-300": !isQualityAssigned,
                    "bg-blue": isQualityAssigned,
                  })}
                >
                  <i className="icon-chevron-right"></i>
                </div>
                <div className="font-sm font-weight-semibold text-gray-700 pl-1">
                  Map Interested Project
                </div>
              </div>
              {addProjectModal && (
                <AddInterestedProject
                  className="accordion__body"
                  leadId={leadState.leadDetails?._id}
                  onClose={() => setAddProjectModal(false)}
                  onSuccess={() => {
                    props.onUpdate?.();
                    setAddProjectModal(false);
                  }}
                ></AddInterestedProject>
              )}
            </div>

            {leadState.leadDetails.company === undefined && (
              <div className="accordion__panel accordion__panel--open">
                <div
                  onClick={() => {
                    if (isQualityAssigned) {
                      setAddMapCompany(true);
                    }
                  }}
                  className={classnames({
                    "accordion__head border d-flex align-items-center rounded cursor-pointer mb-2": true,
                    "bg-gray-100": !isQualityAssigned,
                  })}
                >
                  <div
                    className={classnames({
                      "rounded text-white accordion__head-icon d-flex align-items-center justify-content-center font-xxxs mr-2": true,
                      "bg-gray-300": !isQualityAssigned,
                      "bg-success": isQualityAssigned,
                    })}
                  >
                    <i className="icon-chevron-right"></i>
                  </div>
                  <div className="font-sm font-weight-semibold text-gray-700 pl-1">
                    Assign Company
                  </div>
                </div>
                {addMapCompany && (
                  <AssignCompany
                    className="accordion__body"
                    lead={leadState.leadDetails}
                    onClose={() => setAddMapCompany(false)}
                    onSuccess={() => {
                      props.onReload?.();
                      setAddMapCompany(false);
                    }}
                  ></AssignCompany>
                )}
              </div>
            )}

            {/* {canDeleteLeads && (
              <div className="accordion__panel accordion__panel--open">
                <div
                  onClick={() => {
                    setDeleteModal(true);
                  }}
                  className={classnames({
                    "accordion__head border d-flex align-items-center rounded cursor-pointer mb-2": true,
                  })}
                >
                  <div
                    className={classnames({
                      "rounded text-white accordion__head-icon d-flex align-items-center justify-content-center font-xxxs mr-2 bg-red": true,
                    })}
                  >
                    <i className="icon-chevron-right"></i>
                  </div>
                  <div className="font-sm font-weight-semibold text-gray-700 pl-1">
                    Delete Lead
                  </div>
                </div>
                {deleteModal && (
                  <DeleteLead
                    leadId={leadState.leadDetails?._id}
                    onClose={() => setDeleteModal(false)}
                    onSuccess={() => {
                      props.onUpdate?.();
                      setDeleteModal(false);
                      // getLead(leadState.leadDetails?._id);
                      // reload();
                      history.push(`${RouteKeys.Leads}`);
                    }}
                    isQualityOSL={isQualityOSL}
                    quality={leadState?.leadDetails?.quality}
                  ></DeleteLead>
                )}
              </div>
            )} */}
          </div>
        </div>
      </div>
    </div>
  ) : (
    <div className="p-4 accordion__body border-bottom"></div>
  );
};

export default Actions;
